module.exports = __webpack_public_path__ + "img/star_white.e176540c.svg";